import React from 'react';
import { CheckupRequestInfo, ValidatedVideoLandingPageDefinition } from '@companion-professional/dctypes';
import { VideoPlayer } from '@companion-professional/components';
import "@mux/mux-player";
import { StdLanderBase } from './StdLanderBase';
import { trackEvent } from '../../../../lib/trackEvent';

interface StdVideoLanderPageProps {
  defn: ValidatedVideoLandingPageDefinition;
  checkupRequest: CheckupRequestInfo;
  page: number;
}

export const StdVideoLanderPage = ({ defn, checkupRequest, page }: StdVideoLanderPageProps) => (
  <StdLanderBase
    pageKind="std_video_lander"
    defn={defn}
    checkupRequest={checkupRequest}
    page={page}
    media={
      <VideoPlayer
        muxPlaybackId={defn.mux_playback_id}
        autoPlay={defn.auto_play}
        emitVideoWatchedMetrics={(properties) => {
          trackEvent('instruction_video_watch_metrics', {
            ...properties,
            page: page,
            pageKind: "std_video_lander",
          });
        }}
      />
    }
  />
);
